import FormattedMessage from 'I18n/components/FormattedMessage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AvailableOptionsToggle = ({
  toggleModal = () => {}
}) => /*#__PURE__*/_jsxs(TFlex, {
  align: "center",
  justify: "between",
  gap: 8,
  children: [/*#__PURE__*/_jsx(Button, {
    "data-test-id": "available-options-toggle",
    id: "toggle-available options modal",
    size: "sm",
    use: "tertiary-light",
    onClick: toggleModal,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      "data-test-id": "formatted-message",
      message: "availableOptions.title"
    })
  }), /*#__PURE__*/_jsx(FormattedMessage, {
    "data-test-id": "formatted-message",
    message: "availableOptions.optionsAvailable"
  })]
});
export default AvailableOptionsToggle;